<template>
  <ul
    v-if="categories.length > 0"
    class="list-unstyled mb-0"
  >
    <li
      v-for="category in categories"
      :key="category.systemName"
      class="flex py-1 px-0"
    >
      <div class="row flex-grow-1 items-center">
        <div class="col-4 px-1">
          <div class="embed-responsive mb-0 rounded-sm">
            <RemoteImage
              :src="`https://img.mix.it/general_assets/categories/${category.image}`"
              img-class="embed-responsive-item relative image-contain"
              :alt="category.title"
            />
          </div>
        </div>
        <div class="col-8 px-1">
          <router-link
            v-close-popper
            :to="{ name: 'productsPath', params: { permalink: category.permalink } }"
            class="block stretched-link font-medium underline-hover leading-sm"
          >
            {{ category.title }}
          </router-link>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import RemoteImage from '@/components/general/BaseRemoteImage.vue'
import { useCategoriesStore } from '@/stores/CategoriesStore'

const categoriesStore = useCategoriesStore()

const { getProductCategories } = storeToRefs(categoriesStore)

const props = defineProps({
  searchCategories: {
    type: Array,
    required: true,
  },
})

const categories = computed(() =>
  props.searchCategories.length > 0 ? props.searchCategories : getProductCategories.value.slice(0, 5)
)
</script>
